<template>
  <div class="textBox">
    <transition name="slide">
      <p :key="text.id" class="text">
        <a :href="text.link" target="_blank">💁 {{ text.val }}</a>
      </p>
    </transition>
  </div>
</template>

<script>
export default {
  name: "Scroll",
  data() {
    return {
      number: 0
    };
  },
  computed: {
    textArr() {
      const textList = [
        {
          title: this.$t("home.s1.announce.tt1"),
          link: this.$t("link.index1.ll1")
        },
        {
          title: this.$t("home.s1.announce.tt2"),
          link: this.$t("link.index1.ll2")
        },
        // {
        //   title: this.$t("home.s1.announce.tt3"),
        //   link: this.$t("link.index1.ll3")
        // },
        // {
        //   title: this.$t("home.s1.announce.tt4"),
        //   link: this.$t("link.index1.ll4")
        // }
        // {
        //   title: this.$t("home.s1.announce.t4"),
        //   link: this.$t("link.index1.l9")
        // },
        // {
        //   title: this.$t("home.s1.announce.t1"),
        //   link: this.$t("link.index1.l1")
        // },
        // {
        //   title: this.$t("home.s1.announce.t2"),
        //   link: this.$t("link.index1.l2")
        // }
        // {
        //   title: this.$t("home.s1.announce.tt5"),
        //   link: this.$t("link.index1.ll5")
        // }
        // {
        //   title: this.$t("home.s1.announce.tt6"),
        //   link: this.$t("link.index1.ll6")
        // },
        // {
        //   title: this.$t("home.s1.announce.tt7"),
        //   link: this.$t("link.index1.ll7")
        // },
        // {
        //   title: this.$t("home.s1.announce.tt8"),
        //   link: this.$t("link.index1.ll8")
        // }
      ];
      return textList;
    },
    text() {
      let num;
      if (this.number > 2) {
        num = 0;
      } else {
        num = this.number;
      }
      return {
        id: num,
        val: this.textArr[num].title,
        link: this.textArr[num].link
      };
    }
  },
  created() {
    this.startMove();
  },
  methods: {
    startMove() {
      // eslint-disable-next-line
      let timer = setTimeout(() => {
        if (this.number > 3) {
          this.number = 0;
        } else {
          this.number += 1;
        }
        this.startMove();
      }, 5000); // 滚动不需要停顿则将2000改成动画持续时间
    }
  }
};
</script>

<style lang="less" scoped>
.textBox {
  width: 100%;
  padding-top: 60px;
  margin: 0 auto;
  // overflow: hidden;
  position: relative;
  z-index: 10;
  font-size: 18px;
}
.text {
  width: 100%;
  position: absolute;
  bottom: 0;
  a {
    font-size: 18px;
    font-family: "Microsoft YaHei";
    color: rgba(215, 217, 255, 1);
    line-height: 28px;
  }
}
.slide-enter-active,
.slide-leave-active {
  transition: all 0.5s linear;
}
.slide-enter {
  transform: translateY(20px) scale(1);
  opacity: 1;
}
.slide-leave-to {
  transform: translateY(-20px) scale(0.8);
  opacity: 0;
}
</style>
